/* =========================================================
   k-verifier-ma-piece.js
   Page B2C "Identifier mon poêle" : envoi photo de plaque + infos vers le
   receveur natif (contrat #589), POST multipart/form-data.
   Champs alignés sur docs/VERIFIER_MA_PIECE_CONTRACT.md.
   Logique d'upload adaptée de k-photo-intake.js.
========================================================= */
(function () {
  'use strict';

  var root = document.querySelector('[data-kvmp]');
  if (!root) return;

  var endpoint = root.getAttribute('data-kvmp-endpoint') || '';
  var source = root.getAttribute('data-kvmp-source') || 'verifier-ma-piece-page';
  var sourceUrl = root.getAttribute('data-kvmp-source-url') || '';

  // Attribution : un CTA peut passer ?source=... pour tracer d'ou vient le lead.
  // On ne garde que les valeurs autorisees par le worker (contrat #589/#594).
  var ALLOWED_SOURCES = ['verifier-ma-piece-page', 'finder-fallback', 'product-page', 'guide', 'menu', 'other'];
  var queryParams = null;
  try {
    queryParams = new URLSearchParams(location.search);
    var urlSource = queryParams.get('source');
    if (urlSource && ALLOWED_SOURCES.indexOf(urlSource) !== -1) { source = urlSource; }

    var sourceUrlParam = queryParams.get('source_url');
    if (sourceUrlParam) {
      if (sourceUrlParam.charAt(0) === '/' || sourceUrlParam.indexOf(location.origin + '/') === 0) {
        sourceUrl = sourceUrlParam;
      }
    } else if (document.referrer && document.referrer.indexOf(location.origin + '/') === 0) {
      var referrerUrl = new URL(document.referrer);
      sourceUrl = referrerUrl.pathname + referrerUrl.search;
    }
  } catch (e) {}

  var form = root.querySelector('[data-kvmp-form]');
  var formWrap = root.querySelector('[data-kvmp-form-wrap]');
  var successEl = root.querySelector('[data-kvmp-success]');
  var errorEl = root.querySelector('[data-kvmp-error]');
  var submitBtn = root.querySelector('[data-kvmp-submit]');
  var fileInput = root.querySelector('[data-kvmp-fileinput]');
  var previews = root.querySelector('[data-kvmp-previews]');
  var dropzone = root.querySelector('[data-kvmp-dropzone]');
  var phototypeSel = root.querySelector('[data-kvmp-phototype]');

  // Reprend le contexte du parcours precedent sans imposer au visiteur de le ressaisir.
  if (queryParams) {
    var detailHint = (queryParams.get('detail') || '').trim();
    var modelHint = (queryParams.get('model_hint') || '').trim();
    var messageField = root.querySelector('[data-kvmp-field="message"]');
    var modelField = root.querySelector('[data-kvmp-field="modele"]');

    if (detailHint && messageField && !messageField.value) {
      messageField.value = detailHint.slice(0, 2000);
    }
    if (modelHint && modelField && !modelField.value) {
      modelField.value = modelHint.slice(0, 160);
    }
  }

  /* ---------- 26/10 : marque, modele, plaque ---------- */
  var marqueSel = root.querySelector('[data-kvmp-marque]');
  var modeleSel = root.querySelector('[data-kvmp-modele]');
  var horsEl = root.querySelector('[data-kvmp-hors]');
  var suiteEl = root.querySelector('[data-kvmp-suite]');
  var directEl = root.querySelector('[data-kvmp-direct]');
  var directLink = root.querySelector('[data-kvmp-direct-link]');
  var plaqueEl = root.querySelector('[data-kvmp-plaque]');
  var modeles = [];
  try { modeles = JSON.parse((document.getElementById('kvmp-modeles') || {}).textContent || '[]'); } catch (e) { modeles = []; }

  function majModele() {
    var opt = modeleSel && modeleSel.options[modeleSel.selectedIndex];
    var url = opt ? opt.getAttribute('data-url') : '';
    if (directEl) directEl.hidden = !url;
    if (directLink && url) directLink.setAttribute('href', url);
    if (plaqueEl) plaqueEl.hidden = !!url;
  }

  function majMarque() {
    var opt = marqueSel && marqueSel.options[marqueSel.selectedIndex];
    var valeur = marqueSel ? marqueSel.value : '';
    var handle = opt ? opt.getAttribute('data-handle') : '';
    var horsListe = valeur === 'autre' || valeur === 'inconnue';
    if (horsEl) horsEl.hidden = !horsListe;
    // 01/11 (audit 30 profils) : marque hors liste ou inconnue, la photo reste possible.
    if (suiteEl) suiteEl.hidden = !handle && !horsListe;
    if (!modeleSel) return;
    while (modeleSel.options.length > 1) modeleSel.remove(1);
    modeles.filter(function (m) { return m.m === handle; }).forEach(function (m) {
      var o = document.createElement('option');
      o.value = m.l;
      o.textContent = m.l;
      o.setAttribute('data-url', m.u);
      modeleSel.appendChild(o);
    });
    modeleSel.value = '';
    majModele();
  }

  if (marqueSel) marqueSel.addEventListener('change', majMarque);
  if (modeleSel) modeleSel.addEventListener('change', majModele);

  var MAX_FILES = 2;
  var MAX_SIZE_MB = 10;
  var ALLOWED = ['image/jpeg', 'image/png', 'image/webp', 'image/heic'];
  var SUBMIT_LABEL = 'Identifier mon poêle';

  // Mobile upload hardening: compress browser-decodable photos before multipart upload.
  // HEIC stays untouched because canvas decoding support is not reliable across browsers.
  var COMPRESS_THRESHOLD_BYTES = 2.5 * 1024 * 1024;
  var COMPRESS_MAX_DIMENSION = 2560;
  var COMPRESS_QUALITY = 0.86;

  var files = [];
  var pendingPhotoPreparation = 0;

  /* ---------- erreurs ---------- */
  function showError(msg) { if (!errorEl) return; errorEl.textContent = msg; errorEl.hidden = false; }
  function hideError() { if (!errorEl) return; errorEl.hidden = true; errorEl.textContent = ''; }

  /* ---------- fichiers ---------- */
  function rasterCompressionSupported(file) {
    return file && ['image/jpeg', 'image/png', 'image/webp'].indexOf(file.type) !== -1;
  }

  function compressedFilename(name) {
    var base = String(name || 'photo').replace(/\.[^.]+$/, '');
    return base + '-optimisee.jpg';
  }

  function compressPhoto(file) {
    if (!rasterCompressionSupported(file) || file.size <= COMPRESS_THRESHOLD_BYTES) {
      return Promise.resolve(file);
    }

    return new Promise(function (resolve) {
      var objectUrl = URL.createObjectURL(file);
      var img = new Image();

      function finish(result) {
        URL.revokeObjectURL(objectUrl);
        resolve(result || file);
      }

      img.onload = function () {
        var width = img.naturalWidth || img.width;
        var height = img.naturalHeight || img.height;
        if (!width || !height) { finish(file); return; }

        var scale = Math.min(1, COMPRESS_MAX_DIMENSION / Math.max(width, height));
        var targetWidth = Math.max(1, Math.round(width * scale));
        var targetHeight = Math.max(1, Math.round(height * scale));
        var canvas = document.createElement('canvas');
        canvas.width = targetWidth;
        canvas.height = targetHeight;

        var ctx = canvas.getContext('2d');
        if (!ctx) { finish(file); return; }

        ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
        canvas.toBlob(function (blob) {
          if (!blob || blob.size >= file.size * 0.92) {
            finish(file);
            return;
          }

          try {
            finish(new File([blob], compressedFilename(file.name), {
              type: 'image/jpeg',
              lastModified: file.lastModified || Date.now()
            }));
          } catch (e) {
            blob.name = compressedFilename(file.name);
            finish(blob);
          }
        }, 'image/jpeg', COMPRESS_QUALITY);
      };

      img.onerror = function () { finish(file); };
      img.src = objectUrl;
    });
  }

  function setPhotoPreparationBusy(delta) {
    pendingPhotoPreparation = Math.max(0, pendingPhotoPreparation + delta);
    if (dropzone) dropzone.setAttribute('aria-busy', pendingPhotoPreparation > 0 ? 'true' : 'false');
  }

  function addFiles(list) {
    Array.prototype.forEach.call(list, function (file) {
      if (files.length + pendingPhotoPreparation >= MAX_FILES) {
        showError('Maximum ' + MAX_FILES + ' photos.');
        return;
      }
      // 01/11 (audit 30 profils) : une photo HEIC sans type reconnu (Android, Windows) est acceptee par son extension.
      if (ALLOWED.indexOf(file.type) === -1 && !/\.(jpe?g|png|webp|heic|heif)$/i.test(file.name || '')) {
        showError('Format non accepté (JPG, PNG, WebP, HEIC) : ' + file.name.slice(0, 30));
        return;
      }
      if (file.size > MAX_SIZE_MB * 1024 * 1024) {
        showError('Photo trop lourde (max ' + MAX_SIZE_MB + ' Mo) : ' + file.name.slice(0, 30));
        return;
      }

      setPhotoPreparationBusy(1);
      compressPhoto(file)
        .then(function (prepared) {
          files.push(prepared);
          addPreview(prepared);
          hideError();
        })
        .catch(function () {
          files.push(file);
          addPreview(file);
        })
        .then(function () {
          setPhotoPreparationBusy(-1);
        });
    });
  }

  function addPreview(file) {
    if (!previews) return;
    var thumb = document.createElement('div');
    thumb.className = 'k-vmp__thumb';

    var img = document.createElement('img');
    img.alt = '';
    var reader = new FileReader();
    reader.onload = function (e) { img.src = e.target.result; };
    reader.readAsDataURL(file);
    thumb.appendChild(img);

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'k-vmp__thumb-remove';
    remove.setAttribute('aria-label', 'Retirer cette photo');
    remove.textContent = '×';
    remove.addEventListener('click', function () {
      var i = files.indexOf(file);
      if (i > -1) files.splice(i, 1);
      if (thumb.parentNode) thumb.parentNode.removeChild(thumb);
    });
    thumb.appendChild(remove);
    previews.appendChild(thumb);
  }

  if (fileInput) {
    fileInput.addEventListener('change', function () { addFiles(fileInput.files); fileInput.value = ''; });
  }
  if (dropzone) {
    dropzone.addEventListener('dragover', function (e) { e.preventDefault(); dropzone.classList.add('is-dragover'); });
    dropzone.addEventListener('dragleave', function () { dropzone.classList.remove('is-dragover'); });
    dropzone.addEventListener('drop', function (e) {
      e.preventDefault();
      dropzone.classList.remove('is-dragover');
      if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
    });
  }

  /* ---------- soumission ---------- */
  function fieldVal(key) {
    var el = root.querySelector('[data-kvmp-field="' + key + '"]');
    return el ? el.value.trim() : '';
  }
  function consentChecked(key) {
    var el = root.querySelector('[data-kvmp-consent="' + key + '"]');
    return !!(el && el.checked);
  }

  function submit() {
    var email = fieldVal('email');
    var message = fieldVal('message');

    var marque = fieldVal('marque');
    if (!marque) { showError('Choisissez la marque, ou « Je ne connais pas la marque ».'); return; }
    if (marque === 'autre') marque = 'Marque hors liste';
    if (marque === 'inconnue') marque = 'Marque inconnue';
    // Le message est optionnel : la demande porte toujours sur l'identification du modele.
    message = ('Identification du modèle par la plaque signalétique (' + marque + '). ' + message).trim();
    // 26/10 (simulation visiteurs) : la photo d'abord, c'est l'objet de la demande.
    if (pendingPhotoPreparation > 0) { showError('Vos photos sont encore en cours d’optimisation. Réessayez dans quelques secondes.'); return; }
    if (!files.length) { showError('Ajoutez la photo de la plaque signalétique.'); return; }
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) { showError('Veuillez saisir un email valide.'); return; }
    if (!consentChecked('contact')) { showError('Merci d\'accepter d\'être recontacté(e).'); return; }
    if (!consentChecked('privacy')) { showError('Merci d\'accepter la politique de confidentialité.'); return; }
    if (!endpoint) { showError('Service momentanément indisponible. Écrivez-nous à contact@krepite.fr.'); return; }

    var declaredType = 'plaque-signaletique';
    var fd = new FormData();
    fd.append('intake', 'verifier-ma-piece');
    fd.append('email', email);
    fd.append('message', message);
    fd.append('source', source);
    if (sourceUrl) fd.append('source_url', sourceUrl);
    fd.append('consentement.contact', 'true');
    fd.append('consentement.privacy', 'true');
    var honeypotEl = root.querySelector('[data-krepite-honeypot]');
    fd.append('website', honeypotEl ? honeypotEl.value : '');

    ['nom', 'telephone', 'marque', 'modele', 'type_piece', 'reference'].forEach(function (key) {
      var v = fieldVal(key);
      if (v) fd.append(key, v);
    });

    files.forEach(function (file) {
      fd.append('photos', file);
      fd.append('photo_types', declaredType);
    });

    submitBtn.disabled = true;
    submitBtn.textContent = 'Envoi en cours...';
    hideError();

    fetch(endpoint, { method: 'POST', body: fd })
      .then(function (res) {
        if (!res.ok) throw new Error('http ' + res.status);
        return res.json().catch(function () { return { ok: true }; });
      })
      .then(function (data) {
        if (data && data.ok === false) throw new Error(data.message || 'rejected');
        files = [];
        if (previews) { while (previews.firstChild) previews.removeChild(previews.firstChild); }
        if (form) form.reset();
        if (formWrap) formWrap.hidden = true;
        var aside = root.querySelector('.k-vmp__aside');
        if (aside) aside.hidden = true;
        if (successEl) {
          successEl.hidden = false;
          // 03/11 (lot des ancres) : plus de defilement force ; le message prend la place du formulaire et recoit le
          // focus (le navigateur ne fait defiler que s'il est hors de l'ecran).
          if (!successEl.hasAttribute('tabindex')) successEl.setAttribute('tabindex', '-1');
          successEl.focus();
        }
        submitBtn.disabled = false;
        submitBtn.textContent = SUBMIT_LABEL;
      })
      .catch(function () {
        showError("Impossible d'envoyer votre demande pour le moment. Réessayez ou écrivez à contact@krepite.fr.");
        submitBtn.disabled = false;
        submitBtn.textContent = SUBMIT_LABEL;
      });
  }

  if (form) {
    form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });
  }
}());
